module.exports = __webpack_public_path__ + "static/img/图层8.00b38ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层8.png
// module id = c/uk
// module chunks = 0